import { Card, CardContent, LinearProgress, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import React from 'react';

type DashboardMyAccountsSummaryStatCardProps = {
    icon: React.ReactNode;
    title: string;
    subtitle?: string;
    value: string;
    progressCurrent?: number;
    progressMax?: number;
    selected?: boolean;
    onClick?: () => void;
};

const DashboardMyAccountsSummaryStatCard = ({
    icon,
    title,
    subtitle,
    value,
    progressCurrent = 0,
    progressMax = 0,
    selected = false,
    onClick,
}: DashboardMyAccountsSummaryStatCardProps) => {
    const safeMax = Math.max(0, progressMax);
    const safeCurrent = Math.min(Math.max(0, progressCurrent), safeMax || progressCurrent);
    const showProgress = safeMax > 0 && safeCurrent < safeMax;
    const progressValue = safeMax > 0 ? (safeCurrent / safeMax) * 100 : 0;

    return (
        <Card
            elevation={selected ? 8 : 3}
            onClick={onClick}
            sx={{
                height: '100%',
                position: 'relative',
                overflow: 'hidden',
                cursor: onClick ? 'pointer' : 'default',
                borderWidth: selected ? 2 : 0,
                borderStyle: 'solid',
                borderColor: selected ? 'primary.main' : 'transparent',
            }}
        >
            <CardContent>
                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.5 }}>
                    {icon}
                    <Stack direction="column" spacing={0}>
                        <Typography variant="body1" color="text.secondary">
                            {title}
                        </Typography>
                        <Typography
                            variant="caption"
                            color="text.secondary"
                            textTransform="uppercase"
                            sx={{ lineHeight: 1.1, minHeight: 14 }}
                        >
                            {subtitle || <span>&nbsp;</span>}
                        </Typography>
                    </Stack>
                </Stack>
                <Typography variant="h5" fontWeight={700}>
                    {value}
                </Typography>
            </CardContent>
            {showProgress ? (
                <LinearProgress
                    variant="determinate"
                    value={progressValue}
                    sx={{
                        position: 'absolute',
                        left: 0,
                        right: 0,
                        bottom: 0,
                        height: 3,
                    }}
                />
            ) : null}
        </Card>
    );
};

export default DashboardMyAccountsSummaryStatCard;
